<template>
  <div>
    <!-- v-loading="loading"-->
    <div class="content">
      <div class="details-page">
        <div class="details-page-header">
          <div class="light"></div>
          <div class="details-page-container">
            <div class="details-page-hbox">
              <div class="details-page-col details-page-info" id="detailsInfo">
                <div>
                  <div class="detailsLeft">
                    <img src="../assets/image/sjsy.png" alt="" v-show="tableData.label == '认定项目'" />

                    <h1 class="details-page-info-title">
                      {{ tableData.vrName }}
                    </h1>

                    <div class="topGrade">
                      <span class="scoreOnStyle">
                        <el-rate v-model="theTopScoreData" disabled text-color="#ff9900" score-template="{value}">
                        </el-rate>
                      </span>
                      <span class="ratingScore">({{ theTopScoreData }})分</span>
                    </div>
                  </div>
                  <!-- <div class="details-btns">
                    <button type="button" class="d-btn" @click="clickOnTheCollection()">
                      <i class="iconfont" v-if="collectChange.collectField == ' 已收藏'">
                        <img src="../assets/image/xinhs.png" class="theNotificationIcon" alt="" />
                      </i>
                      <i class="iconfont" v-if="collectChange.collectField == ' 收藏'"><img
                          src="../assets/image/icon-scang.png" class="theNotificationIcon" alt="" /></i>

                      {{ collectChange.collectField }}
                    </button>

                    <button type="button" class="d-btn" @click="thumbUpClick()">
                      <i class="iconfont" v-if="collectChange.thumbUpField == ' 已点赞'">
                        <img src="../assets/image/zanhs.png" class="theNotificationIcon" alt="" />
                      </i>

                      <i class="iconfont" v-if="collectChange.thumbUpField == ' 点赞'"><img
                          src="../assets/image/icon-dzan.png" class="theNotificationIcon" alt="" /></i>
                      {{ collectChange.thumbUpField
                      }}<s>({{ tableData.thumbNum || 0 }})</s></button><button type="button" class="d-btn"
                      id="shareBtn">
                      <i class="iconfont">
                        <img src="../assets/image/sa.png" class="theNotificationIcon" alt="" />
                      </i>
                      申报年份 2022 年
                
                    </button>
                  </div> -->
                  <div class="details-page-info-score" id="infoScore"></div>
                </div>
                <div class="detailsTableStyle">

                  <div class="headEtc">
                    <span class="head">
                      <span class="titleOfPrincipal">学校名称：</span>
                      <span class="contentOfResponsiblePerson">辽宁省交通高等专科学校</span>
                    </span>
                    <span class="head">
                      <span class="titleOfPrincipal">专业名称：</span>
                      <span class="contentOfResponsiblePerson">{{ tableData.collegeName }}</span>
                    </span>
                    <span class="head">
                      <span class="titleOfPrincipal">项目负责人：</span>
                      <span class="contentOfResponsiblePerson"> {{ classTypes(tableData.teacherName) }}</span>
                    </span>
                  </div>


                </div>
                <div @click="open(tableData.intro)">
                  <!--changeTheStyle-->
                  <span class="details-page-info-description" :title="tableData.intro" v-html="tableData.intro"></span>
                  <!--theNumberDisplayed-->
                  <!-- <span class="moreAndMore" v-show="moreApparentConcealed == true"
                    @click.stop="open(tableData.intro)">更多></span> -->
                </div>

                <div class="details-page-info-btns">
                  <button type="button" class="btn btn-primary details-page-info-do-btn" @click="clickOnTheTraining()">
                    我要做实验
                  </button>
                </div>
              </div>
              <div class="details-page-col details-page-thumb">
                <div class="videoTab clearfix">
                  <a href="javascript:void(0);" class="videoType on" data-video-type="1">实验简介视频</a>
                </div>
                <div class="details-page-thumb-frame">
                  <video id="myVideo" class="" autoplay="muted" controls :src="imagePath(accessToVideo.url)"
                    preload="auto" poster=""></video>
                </div>
                <div class="details-page-thumb-frame hide" id="video02"></div>
              </div>
            </div>
          </div>
        </div>

        <!--实验-->
        <div v-show="practiceShowsThat === true">
          <div id="dialog_bg" style=""></div>
          <div id="dialog_panel" class="" style="margin-left: -10%; margin-top: 10px">
            <div id="dialog_panel_bg"></div>
            <div id="dialog_title" style="display: block">跳转提示</div>
            <div id="dialog_content">
              <p class="goLink-tip">您将要离开本站前往其他网站，确认请点击下面的链接。</p>
              <p class="goLink-link">
                <a :href="thereIsNoConnection(nextProjectIsIntroduced.effectiveUrl)" @click="clickTheLink()"
                  target="_blank">
                  {{ thereIsNoConnection(nextProjectIsIntroduced.effectiveUrl) }}</a>
                <!-- <a :href="tableData.shareUrl" @click="clickTheLink()" target="_blank">
                  {{ thereIsNoConnection(tableData.shareUrl) }}</a
                > -->
                <a style="color: red" v-show="noData == true">无有效访问链接</a>
              </p>
            </div>
            <div id="dialog_control" style="">
              <a href="javascript:void(0)" id="dialog_close" class="button" style="display: none" marked="1">取消</a><a
                class="button col2" marked="1" style="display: inline-block" @click="practiceShowsThat = false">取消</a>
            </div>
          </div>
        </div>

        <div class="details-page-body">
          <div class="details-page-container">
            <div class="details-page-hbox details-page-container">
              <div class="details-page-col details-page-discuss" id="detailsPageInfo">
                <div style="padding: 20px">
                  <div class="desc-tab">
                    <div class="desc-tab-container">
                      <span class="desc-tab-item" v-for="(item, index) in projectDescriptionColumn" :key="index"
                        @click="clickOnTheStep(index)" :class="{ on: msg === index }">{{ item.label }}</span>

                    </div>
                  </div>
                  <!--项目步骤内容-->
                  <div class="content-part part1" v-show="msg == index" v-for="(item, index) in projectDescriptionColumn"
                    :key="index">
                    <div class="part-content publish">
                      <div class="projectBigBox">
                        <!-- <div class="detailsOfTheName">项目名称</div> -->
                        <div class="theProjectContent changeTheStyle" v-html="item.content"></div>
                      </div>


                    </div>
                  </div>


                </div>
              </div>
              <div class="details-page-col details-page-stat" id="stat" style="display: table-cell">
                <div class="details-page-stat-box hotline-box">
                  <h3 class="details-page-stat-title">教学支持热线</h3>
                  <div class="details-page-stat-hotline" id="hotline">
                    <div class="h-item">
                      <i class="iconfont w4"><s>热线</s></i><span class="h-item-p1">{{ tableData.phoneNo || "无" }}</span>
                    </div>
                    <div class="more-content hide">
                      <div class="h-item">
                        <i class="iconfont w10"><s>实验系统即时通讯工具</s></i>腾讯QQ
                      </div>
                      <div class="h-item">
                        <i class="iconfont w5"><s>支持与服务群</s></i>QQ群
                      </div>
                    </div>
                    <!-- <div class="more-btn close" title="展开">
                      <i class="iconfont"></i>
                    </div> -->
                  </div>
                </div>
                <div class="details-page-stat-box teachTeam-box">
                  <h3 class="details-page-stat-title">团队成员</h3>
                  <!-- <a href="javascript:" class="team-teach">教学团队</a> -->
                  <div class="details-page-stat-teachTeam" id="teachTeam">
                    <!-- <div class="h-item leader-first hide">
                      <i class="iconfont"><s>负责人</s></i
                      ><span class="h-item-name">吴涛</span
                      ><span class="h-item-unit">滨州学院</span>
                    </div> -->
                    <div class="more-content">
                      <div class="h-item">
                        <i class="iconfont"><s>姓名</s></i><span class="h-item-name">{{
                            theTeachingTeam.projectLeader || "无"
                        }}</span>
                      </div>
                      <div class="h-item">
                        <i class="iconfont"><s>单位</s></i><span class="h-item-name">{{
                            tableData.schoolName || "无"
                        }}</span>
                      </div>
                      <div class="h-item">
                        <i class="iconfont"><s>职务</s></i><span class="h-item-name">{{
                            theTeachingTeam.technicalPosition || "无"
                        }}</span>
                      </div>
                      <div class="h-item">
                        <i class="iconfont w4"><s>承担职务</s></i><span class="h-item-name">{{
                            theTeachingTeam.administrativePosition || "无"
                        }}</span>
                      </div>
                      <div class="h-item-tab">
                        <span class="tab-item" @click="msgs = 0" :class="{ on: msgs === 0 }">主要成员</span><span
                          class="tab-item t2" key="" @click="msgs = 1" :class="{ on: msgs === 1 }">其他成员</span>
                      </div>
                      <div class="h-item-mainteam" v-show="msgs === 0">
                        <div class="h-item" v-for="(item, index) in theMainMembersOfTheData" :key="index">
                          <i class="iconfont w4"><s>主要成员</s></i><span class="h-item-name">{{ item.name || "无"
                          }}</span><span class="h-item-unit" :title="item.company">{{
    character(item.company)
}}</span>
                        </div>
                        <div class="noData" v-show="theMainMembersOfTheData.length == 0">
                          暂无成员
                        </div>
                      </div>
                      <div class="h-item-otherteam" v-show="msgs === 1">
                        <div class="h-item" v-for="(item, index) in theOtherMembers" :key="index">
                          <i class="iconfont w4"><s>其他成员</s></i><span class="h-item-name">{{ item.name || "无"
                          }}</span><span class="h-item-unit" :title="item.company">{{
    character(item.company)
}}</span>
                        </div>

                        <div class="noData" v-show="theOtherMembers.length == 0">
                          暂无成员
                        </div>
                      </div>
                    </div>
                    <!-- <div class="more-btn" title="关闭">
                      <i class="iconfont"></i>
                    </div> -->
                  </div>
                </div>
                <div class="details-page-stat-box">
                  <h3 class="details-page-stat-title">
                    共享应用<span class="title-tip-small">
                      <font class="red">注：</font>每日0点更新
                    </span>
                  </h3>
                  <ul class="details-page-stat-shared">
                    <li class="first">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">
                        实验浏览量
                        <span>0</span>
                      </div>
                    </li>
                    <li class="fifth">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">
                        实验人次<i class="iconfont tip-icon"></i>
                        <span>0</span>
                      </div>
                      <div class="share-tip">
                        <p>
                          “实验人次”是指用户参与实验的总次数。同一个用户可以做多次实验，实验人次会依次累加。
                        </p>
                      </div>
                    </li>
                    <li class="second">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">
                        实验人数<i class="iconfont tip-icon"></i>
                        <span></span>
                      </div>
                      <div class="share-tip">
                        <p>“实验人数”是指参与实验的用户总人数。注意：</p>
                        <p>1.同一个用户多次实验，实验人数只统计为1人，不累加；</p>
                        <p>2.“实验人数”只统计已回传成绩的用户人数总和；</p>
                        <p>
                          3.“已回传成绩”指学生完成实验后，实验接口成功返回学生实验数据；
                        </p>
                        <p>
                          4.验证“已回传成绩”的方式：参与实验人员可以在<font class="brown">个人中心-我的项目-我的成绩</font>中查看是否可以进行“实验评价”，实验负责老师可以在
                          <font class="brown">申报管理-成绩查看</font>中查看是否有学生成绩；
                        </p>
                        <p>5.共享应用中的所有统计数据均在每日0点～1点更新。</p>
                      </div>
                    </li>
                    <li class="six">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">
                        实验平均用时
                        <span>0</span>
                      </div>
                    </li>
                    <li class="seven">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">
                        实验完成率<i class="iconfont tip-icon"></i>
                        <span>0%</span>
                      </div>
                      <div class="share-tip">
                        <p>“实验完成率”是指完成实验的次数占参与实验总次数的百分比。</p>
                      </div>
                    </li>
                    <li class="third">
                      <div class="icon">
                        <i class="iconfont" style="
                            background-color: #fff;
                            color: #339900;
                            border-radius: 4px;
                            font-size: 25px;
                          "></i>
                      </div>
                      <div class="label">
                        实验通过率<i class="iconfont tip-icon"></i>
                        <span>0%</span>
                      </div>
                      <div class="share-tip">
                        <p>
                          “实验通过率”是指实验成绩60分及以上的次数占实验总次数的百分比。
                        </p>
                      </div>
                    </li>
                  </ul>
                  <div class="details-page-hbox grade-box">
                    <div class="details-page-col details-page-stat-grade">
                      <ul>
                        <li class="good">
                          <span class="line line1">优秀 0人</span>
                          <div class="share-tip">
                            <p>成绩≥85</p>
                          </div>
                        </li>
                        <li class="standard">
                          <span class="line line1">达标 0人</span>
                          <div class="share-tip">
                            <p>60≤成绩&lt;85</p>
                          </div>
                        </li>
                        <li class="failed">
                          <span class="line line1">不达标 0人</span>
                          <div class="share-tip">
                            <p>成绩&lt;60</p>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="schart-box">
                      <!-- <schart class="schart" canvasId="pie" :options="options3" style="width: 100px;height: 100px;"></schart> -->
                    </div>
                  </div>
                </div>
                <div class="details-page-stat-box course-quote hide">
                  <h3 class="details-page-stat-title">
                    课程说明<a class="stat-title-more" href="/cloud">更多<i class="iconfont"></i></a>
                  </h3>
                  <ul class="details-page-stat-shared" id="course-quote">
                    <li class="first">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">开课课程情况<span>0</span></div>
                    </li>
                    <li class="fifth">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">开设班级数量<span>0</span></div>
                    </li>
                    <li class="second">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">覆盖学校数量<span>0</span></div>
                    </li>
                  </ul>
                  <div class="score-tip-small">
                    <font class="red">注：</font>每日0点更新
                  </div>
                </div>
                <!-- <div class="details-page-stat-box course-box">
                  <h3 class="details-page-stat-title">开课情况</h3>
                  <div id="course-box"><div class="noitems">暂无内容</div></div>
                </div> -->
                <div class="details-page-stat-box score-box">
                  <h3 class="details-page-stat-title">
                    实验评分<span class="score-num">{{ assessNum }}人评分</span>
                  </h3>
                  <div class="details-page-stat-evaluate" id="evaluate">
                    <div class="star-ctn clearfix">
                      <div class="star-item item1" data-id="1">
                        <span class="score-txt">{{ scoreDataShow.star1 }}.0</span>
                        <p class="star-title">
                          <el-rate v-model="scoreDataShow.star1" disabled text-color="#ff9900" score-template="{value}">
                          </el-rate>
                        </p>
                        <p class="score-title">实验内容</p>
                      </div>
                      <div class="star-item item2" data-id="2">
                        <span class="score-txt">{{ scoreDataShow.star2 }}.0</span>
                        <p class="star-title">
                          <el-rate v-model="scoreDataShow.star2" disabled text-color="#ff9900" score-template="{value}">
                          </el-rate>
                        </p>
                        <p class="score-title">操作系统</p>
                      </div>
                      <div class="star-item item3" data-id="3">
                        <span class="score-txt">{{ scoreDataShow.star3 }}.0</span>
                        <p class="star-title">
                          <el-rate v-model="scoreDataShow.star3" disabled text-color="#ff9900" score-template="{value}">
                          </el-rate>
                        </p>
                        <p class="score-title">支持服务</p>
                      </div>
                      <div class="score-tip-small">
                        <font class="red">注：</font>每日0点更新，完成实验后请前往“个人中心-我的项目-实验评价”中进行实验评价。
                      </div>
                    </div>
                  </div>
                  <div class="evaluate-btns">
                    <span class="vote-btn" @click="toEvaluate()">去评价</span>
                  </div>
                </div>
                <div class="details-page-stat-box evaluate-box">
                  <h3 class="details-page-stat-title">实验评论</h3>
                  <ul class="details-page-stat-shared">
                    <li class="eight">
                      <div class="icon"><i class="iconfont"></i></div>
                      <div class="label">评论数 <span>0</span></div>
                    </li>
                  </ul>

                  <div class="noData" v-show="noComments.reviewCode == 0">暂无评论</div>
                  <div v-for="(item, index) in curriculumEvaluationData" :key="index">
                    <div class="problem-content">
                      {{ item.content }}
                    </div>
                    <div class="problem-info">
                      <span class="name"> {{ item.replyUserName }}</span><span class="name">{{ item.replyTime }}</span>
                    </div>
                  </div>

                  <!-- <div class="evaluate-btns evaluate-more">
                    <a href="/details/vote?id=6078" class="more-vote-btn"
                      >更多<i class="iconfont"></i></a
                    >
                  </div> -->
                </div>
              </div>
              <div class="resource-box-container hide" style="display: none"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import "../assets/js/jquery.js";
// import "../assets/js/discipline_Class.js";

import { conditionalExpression } from "@babel/types";
import { ref, reactive } from "vue";
import {
  clickOnTheExperiment,
  curriculumEvaluationList,
  theSharedApplication,
  collection,
  giveALike,
  testScore,
  iWantToBePractical,
  deleteTheCollection,
  iWantToPracticer,
} from "../assets/api/index";

import router from "../router/index.js";
import { useRoute } from "vue-router";

import { ElMessage, ElMessageBox } from "element-plus";
import Video from "video.js";
// import "video-js.css";
import { videoPlayer } from "vue-video-player";
import "videojs-flash";
import Schart from "vue-schart";
import imagePath from "../assets/js/config.js";
export default {
  setup() {
    const Route = useRoute();
    const loading = ref(true);

    const practiceShowsThat = ref(false);
    const tableData = ref([]);
    const theTeachingTeam = ref([]);
    const theMainMembersOfTheData = ref([]);
    const theOtherMembers = ref([]);
    const accessToVideo = ref([]);
    const curriculumEvaluationData = ref([]);
    const courseid = Route.query.courseid;
    const userId = localStorage.getItem("userId");
    const projectDescriptionColumn = ref([]);

    //获取数据
    const forMoreDetailsData = () => {
      clickOnTheExperiment(Route.query.theId).then((res) => {
        tableData.value = res.data;




        //项目描述栏目以及内容

        projectDescriptionColumn.value = res.data.courseExtList;







        if (JSON.parse(res.data.file2)[0].url == '') {

        } else {
          accessToVideo.value = JSON.parse(res.data.file2)[0];
        }

      });
    };
    forMoreDetailsData();

    //收藏
    const collectTheRequest = reactive({
      courseId: Route.query.courseid,
      uid: localStorage.getItem("userId"),
    });

    //删除收藏
    const cancelTheCollection = () => {
      deleteTheCollection(collectTheRequest).then((res) => {
        if (res.code == 200) {
          ElMessage.success(res.msg);
          collectChange.collectField = " 收藏";
        }
      });
    };

    const collectChange = reactive({
      collectField: " 收藏",
      thumbUpField: " 点赞",
    });
    const clickOnTheCollection = () => {
      collection(collectTheRequest).then((res) => {
        if (res.code == 200) {
          ElMessage.success(res.msg);
          collectChange.collectField = " 已收藏";
        } else if (res.msg == "请登录或者注册后尝试") {
          ElMessage.info(res.msg);
        } else {
          collectChange.collectField = " 已收藏";
          // ElMessage.info(res.msg);
          cancelTheCollection();
        }
      });
    };

    //点赞点击

    const thumbUpClick = () => {
      giveALike(collectTheRequest).then((res) => {
        if (res.code == 200) {
          cancelTheCollection();
          ElMessage.success(res.msg);
          collectChange.thumbUpField = " 已点赞";
        } else if (res.msg == "请登录或者注册后再次尝试") {
          ElMessage.info(res.msg);
        } else {
          collectChange.thumbUpField = " 已点赞";
          ElMessage.info(res.msg);
        }
      });
    };

    const toDeclareTheThird = ref([]);

    //课程详情

    // const forTheRequest = reactive({
    //   id: 1,

    // });
    const theExperimentalClass = ref([]);
    const theExperimentalSteps = ref([]);
    const skillPointsC = ref([]);
    const literacyPointData = ref([]);
    const nextProjectIsIntroduced = ref([]);

    //课程详情评论
    const noComments = reactive({
      reviewCode: null,
    });
    const toObtainAListEvaluation = () => {
      curriculumEvaluationList(courseid).then((res) => {
        curriculumEvaluationData.value = res.data;
        console.log(res.data);
        if (res.data == "") {
          noComments.reviewCode = 0;
        } else {
          noComments.reviewCode = 1;
        }
      });
    };
    toObtainAListEvaluation();

    //共享应用

    // const sharingApplicationRequest = reactive({

    //   id:localStorage.getItem("courseid"),
    // });

    //去评价
    const toEvaluate = () => {
      let token = localStorage.getItem("token");
      if (token) {
        router.push({ path: "theExperimentalEvaluation" });
      } else {
        ElMessage.info("请登录后在来评论！");
      }
      // router.push({ path: "theExperimentalEvaluation" });
    };

    const classTypes = (value) => {
      switch (value) {
        case "0":
          return "专业基础课";
          break;

        case "1":
          return "专业核心课";
          break;

        case "2":
          return "专业拓展课";
          break;

        case "3":
          return "岗位实习";
          break;
      }
    };

    //实验评分回显
    const scoreDataShow = ref([]);
    const assessNum = ref([]);
    const theExperimentScoreEcho = () => {
      testScore(Route.query.courseid).then((res) => {
        assessNum.value = res.assessNum;
        if (res.avgAssess != null) {
          scoreDataShow.value = res.avgAssess;
        }
      });
    };
    theExperimentScoreEcho();

    //我要实验
    const trainingToken = reactive({
      ticket: null,
    });

    const iWantToPracticeData = ref([]);
    const clickOnTheTraining = () => {
      window.open(
        "http://" +
        "120.46.140.235:9012/main/simulation/index?experimentId=" +
        Route.query.theId,
        "_blank"
      );
      // iWantToPracticer(userId).then((res) => {
      //   trainingToken.ticket = res.data;

      //   console.log(trainingToken.ticket);
      // });

      // let token = localStorage.getItem("token");
      // if (token) {
      //   practiceShowsThat.value = true;
      // } else {
      //   ElMessage.info("请登录后操作！");
      // }

    };

    //点击链接

    const clickTheLink = () => {
      iWantToBePractical(collectTheRequest).then((res) => {
        if (res.code == 400) {
          ElMessage.error(res.msg);
        } else {
          ElMessage.success(res.msg);
        }
      });
    };

    const theTopScoreData = ref(0);

    //无有效连接
    const noData = ref(false);
    const thereIsNoConnection = (value) => {
      if (value == undefined || value == null) {
        noData.value = true;
      } else {
        noData.value = false;
        var cen = "";
        if (value.indexOf("?") == -1) {
          cen = value + "?ticket=" + trainingToken.ticket;
        } else {
          cen = value + "&ticket=" + trainingToken.ticket;
        }

        return cen;
      }
    };

    //饼状图
    const options3 = {
      type: "pie",
      title: {
        text: "达标人数",
      },
      legend: {
        position: "center",
      },
      bgColor: "#fbfbfb",
      labels: ["优秀", "达标", "不达标"],
      datasets: [
        {
          data: [334, 278, 190],
        },
      ],
    };

    const character = (value) => {
      if (value.length > 9) {
        return value.slice(0, 9) + "...";
      } else {
        return value;
      }
    };

    const open = (value) => {
      ElMessageBox.alert("" + value + "", "实验简介", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
      });
    };
    const moreApparentConcealed = ref(true);

    // const theNumberDisplayed = (values)=>{
    //   if (values.length > 300) {
    //       moreApparentConcealed.value=true;
    //         return values;
    //   } else {
    //   moreApparentConcealed.value=false;
    //  return values;
    //   }
    // }

    //点击步骤
    const msg = ref(0);
    const clickOnTheStep = (index) => {
      msg.value = index;
    };

    return {
      msg,
      //点击步骤
      clickOnTheStep,
      imagePath,
      //获取数据
      forMoreDetailsData,

      open,
      moreApparentConcealed,
      trainingToken,
      // theNumberDisplayed,
      character,
      options3,
      classTypes,
      noData,
      clickOnTheTraining,
      clickTheLink,
      cancelTheCollection,
      thereIsNoConnection,
      theTopScoreData,
      noComments,
      skillPointsC,
      nextProjectIsIntroduced,
      theExperimentalSteps,
      theExperimentalClass,
      loading,
      toDeclareTheThird,
      assessNum,
      collectChange,
      scoreDataShow,
      iWantToPracticeData,
      tableData,
      accessToVideo,
      courseid,
      msg,
      theTeachingTeam,

      practiceShowsThat,
      theMainMembersOfTheData,
      theOtherMembers,
      curriculumEvaluationData,
      literacyPointData,
      thumbUpClick,
      clickOnTheCollection,
      toEvaluate,
      toObtainAListEvaluation,
      projectDescriptionColumn,
    };
  },

  name: "projectDetails",
  components: {
    Schart,
  },
};
</script>

<style src="../assets/css/xiangqing/common.css" scoped>

</style>
<style src="../assets/css/xiangqing/details-page-2020.css" scoped>

</style>
<style src="../assets/css/xiangqing/details-page-v2.css" scoped>

</style>
<style src="../assets/css/xiangqing/details-page-v3.css" scoped>

</style>
<style src="../assets/css/xiangqing/video-js-v5.19.2.min.css" scoped>

</style>
<style src="../assets/css/xiangqing/header_v5.css" scoped>

</style>
<style src="../assets/css/xiangqing/dialog.css" scoped>

</style>

<style>
video {
  width: 96%;
  height: 297px;
  position: absolute;
  top: -1px;
  left: 10px;
}

.detailsOfTheName {
  font-size: 15px;
  font-weight: lighter;
  margin-bottom: 12px;
  color: #666;
}

.theProjectContent {
  font-size: 14px;
  color: #000;
  margin-top: 9px;
  margin-bottom: 13px;
  text-indent: 10px;
}

.projectBigBox {
  margin-bottom: 25px !important;
}

.detailsLeft img {
  float: left;
  margin-right: 14px;
}

.theProjectContent table {
  width: 100%;
}

.theProjectContent table tr {
  height: 50px;
  border: 1px solid #eee;
}

.theProjectContent table tr th {
  background: #f8faff;
  font-weight: normal;
  border-right: 1px solid #eee;
}

.theProjectContent table tr td {
  text-align: center;
  border-right: 1px solid #eee;
}

.changeTheStyle>>>p {
  font-size: 14px !important;
  font-family: "微软雅⿊" !important;
  line-height: 28px;
  cursor: pointer;
}

.changeTheStyle>>>span {
  font-size: 14px !important;
  font-family: "微软雅⿊" !important;
  line-height: 28px;
}

.detailsTableStyle {
  margin-top: 28px !important;
  position: relative;

}

.headEtc {
  color: #FFFFFF85;
}

.head {
  margin-right: 40px;
}

.theNameOfThe {
  text-align: end;
  width: 84px;
}

.detailsTableStyle table {
  width: 100%;
  opacity: 0.5;
}

.theNotificationIcon {
  width: 12px;
  position: relative;
  top: 1px;
}

.scoreOnStyle {
  display: inline-block;
}

.ratingScore {
  font-size: 12px;
  margin-left: 4px;
}

.topGrade {
  margin-top: 5px !important;
  margin-bottom: 12px !important;
}

.noData.countlessAccordingToStyle {
  text-align: center;
  display: block;
}

#pie {
  border-radius: 50%;
}

.details-page-info-description span {
  display: inline-block;
  margin-right: 6px;
  cursor: pointer;
}

.moreAndMore {
  font-size: 12px !important;
  color: #fff;
  opacity: 0.5;
  cursor: pointer;
}

.theProjectContent.changeTheStyle img {
  max-width: 100%;
}
</style>
